const errorLogger = (error: Error | string): void => {
  if (!isProduction) {
    console.error(error);
  }
};

export default errorLogger;
